import { render, staticRenderFns } from "./ServerSettings.vue?vue&type=template&id=4f4585fe&scoped=true"
import script from "./ServerSettings.vue?vue&type=script&lang=js"
export * from "./ServerSettings.vue?vue&type=script&lang=js"
import style0 from "./ServerSettings.vue?vue&type=style&index=0&id=4f4585fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4585fe",
  null
  
)

export default component.exports